<template>
<div v-if="account && account.length > 1"><div id="fb-root"></div>
  <div
    class="fb-page"
    :data-href="`https://www.facebook.com/${account}/`"
    data-tabs="timeline,events,messages"
    data-width="400px"
    data-height=""
    data-small-header="false"
    data-adapt-container-width="true"
    data-hide-cover="false"
    data-show-facepile="true"
    style="width: 100%"
  >
    <blockquote
      :cite="`https://www.facebook.com/${account}/`"
      class="fb-xfbml-parse-ignore"
    >
      <a
        :href="`https://www.facebook.com/${account}/`"
      >
        {{ account }}
      </a>
    </blockquote>
  </div>
</div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    props: {
      account: {
        type: String,
        required: false,
        default: null,
      },
    },
    data: () => ({
      recaptchaScript: null
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
    },
    mounted () {
      this.resetScript()
    },
    updated () {
      this.resetScript()
    },
    methods:{
      resetScript () {
        // INI script para la integración de facebook
        //const script = 'https://connect.facebook.net/es_ES/sdk.js#xfbml=1&version=v3.3'
        const script = 'https://connect.facebook.net/es_ES/sdk.js#xfbml=1&version=v12.0'
        this.recaptchaScript = document.createElement('script')
        this.recaptchaScript.setAttribute('src', script)
        this.recaptchaScript.setAttribute('crossorigin', 'anonymous')
        this.recaptchaScript.setAttribute('async', 'true')
        this.recaptchaScript.setAttribute('defer', 'true')
        document.head.appendChild(this.recaptchaScript)
        // END script para la integración de facebook
      }
    }
  }
</script>
<style scoped>
</style>
